export type ToastType = 'success' | 'error' | 'info';

export function showToast(message: string, type: ToastType = 'success') {
  try {
    const ev = new CustomEvent('app:toast', { detail: { message, type } });
    window.dispatchEvent(ev);
  } catch (e) {
    // fallback: console
    // eslint-disable-next-line no-console
    console.log('Toast:', type, message);
  }
}

export default { showToast };
